import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "container px-0" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-xl-3 col-md-6 mb-4"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row no-gutters align-items-center" }
const _hoisted_7 = { class: "col mr-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-primary text-uppercase mb-1" }, " Pending Deposits ", -1)
const _hoisted_9 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fas fa-wallet fa-2x text-gray-300" })
], -1)
const _hoisted_11 = {
  key: 1,
  class: "col-xl-3 col-md-6 mb-4"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row no-gutters align-items-center" }
const _hoisted_14 = { class: "col mr-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-success text-uppercase mb-1" }, " Pending Withdrawals ", -1)
const _hoisted_16 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-university fa-2x text-gray-300" })
], -1)
const _hoisted_18 = {
  key: 2,
  class: "col-xl-3 col-md-6 mb-4"
}
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "row no-gutters align-items-center" }
const _hoisted_21 = { class: "col mr-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-danger text-uppercase mb-1" }, " Pending Manual Orders ", -1)
const _hoisted_23 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-exclamation-triangle fa-2x text-gray-300" })
], -1)
const _hoisted_25 = {
  key: 3,
  class: "col-xl-3 col-md-6 mb-4"
}
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "row no-gutters align-items-center" }
const _hoisted_28 = { class: "col mr-2" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-warning text-uppercase mb-1" }, " Customer Management ", -1)
const _hoisted_30 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-id-card fa-2x text-gray-300" })
], -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "row animated fadeIn" }
const _hoisted_34 = { class: "col-xl-12 col-lg-12" }
const _hoisted_35 = { class: "card shadow mb-4" }
const _hoisted_36 = /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, " Full Ledger ", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-down" }, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "card-body"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_40 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminSubNavbar = _resolveComponent("AdminSubNavbar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_AccountStatement = _resolveComponent("AccountStatement")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.$permissions.generals['customer_management'])
      ? (_openBlock(), _createBlock(_component_AdminSubNavbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.$permissions.generals['pending_deposit'])
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", {
                class: ["card dashboard-top-card border-left-primary shadow h-100 py-2", { active: _ctx.$route.path == '/dashboard/deposits' }],
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveTo('/dashboard/deposits')))
              }, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode("div", _hoisted_9, _toDisplayString(_ctx.cards?.pendingDeposits !== undefined
                        ? _ctx.cards.pendingDeposits
                        : ' '), 1)
                    ]),
                    _hoisted_10
                  ])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.$permissions.generals['pending_withdrawals'])
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("div", {
                class: ["card dashboard-top-card border-left-success shadow h-100 py-2", {
              active: _ctx.$route.path == '/dashboard/pending-withdrawals'
            }],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveTo('/dashboard/pending-withdrawals')))
              }, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.cards?.pendingWithdrawals !== undefined
                        ? _ctx.cards.pendingWithdrawals
                        : ' '), 1)
                    ]),
                    _hoisted_17
                  ])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.$permissions.generals['pending_manual_orders'])
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode("div", {
                class: ["card dashboard-top-card border-left-danger shadow h-100 py-2", {
              active: _ctx.$route.path == '/dashboard/unfilled-orders'
            }],
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moveTo('/dashboard/unfilled-orders')))
              }, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode("div", _hoisted_23, _toDisplayString(_ctx.cards?.pendingOrders !== undefined
                        ? _ctx.cards.pendingOrders
                        : ' '), 1)
                    ]),
                    _hoisted_24
                  ])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.$permissions.generals['pending_customer_verification'])
          ? (_openBlock(), _createBlock("div", _hoisted_25, [
              _createVNode("div", {
                class: ["card dashboard-top-card border-left-warning shadow h-100 py-2", { active: _ctx.$route.path == '/dashboard/pending-users' }],
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moveTo('/dashboard/pending-users')))
              }, [
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode("div", _hoisted_30, _toDisplayString(_ctx.cards?.pendingCustomers !== undefined
                        ? _ctx.cards.pendingCustomers
                        : ' '), 1)
                    ]),
                    _hoisted_31
                  ])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$route.path != '/dashboard')
        ? (_openBlock(), _createBlock("div", _hoisted_32, [
            _createVNode(_component_router_view, {
              key: _ctx.$route.path
            }, {
              default: _withCtx(({ Component }) => [
                _createVNode(_Transition, { name: "slide-fade" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_33, [
        _createVNode("div", _hoisted_34, [
          _createVNode("div", _hoisted_35, [
            _createVNode("div", {
              class: "card-header py-3 d-flex flex-row align-items-center justify-content-between",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.showToggle()), ["prevent"]))
            }, [
              _hoisted_36,
              _createVNode("a", {
                class: ["show-toggle", { show: _ctx.show }]
              }, [
                _hoisted_37
              ], 2)
            ]),
            (_ctx.show)
              ? (_openBlock(), _createBlock("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", null, [
                      _createVNode(_component_AccountStatement)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}